module.exports = __webpack_public_path__ + "static/img/succsee.ee519490.png";